var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "scroll-top",
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "outlined": "",
      "transition": "slide-x-transition"
    },
    on: {
      "click": function ($event) {
        return _vm.$vuetify.goTo(_vm.target, _vm.options);
      }
    }
  }, [_c('span', {
    staticClass: "font-size-10 font-size-lg-14"
  }, [_vm._v("TOP")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }